import { formatNumber } from './dataUtils';

const isValidateQRCode = (
  billerId?: string,
  ref1?: string,
  customerCode?: string,
  ivNo?: string,
) => !!billerId && !!ref1 && !!customerCode && !!ivNo;

const generateQRCodePaymentValue = (
  billerId?: string,
  ref1?: string,
  customerCode?: string,
  ivNo?: string,
  amount?: number,
) => {
  return `|${billerId}\n${ref1}\n${customerCode?.slice(0, 8)}${ivNo?.slice(-8)}\n${parseInt(
    // eslint-disable-next-line no-useless-escape
    formatNumber(Number(amount || 0), 2, 2).replace(/[,\.]/g, ''),
    10,
  )}`;
};

export { generateQRCodePaymentValue, isValidateQRCode };
